const profilesQuery = `query {
        getUserProfileInfo {
            EmployerProfiles {
                employer_id
                employer_name
            }
            EmployerPOCProfiles {
                employer_poc_id
                employer_poc_name
            }   
            AgentProfiles {
                agent_id
                agent_name
            }
            AgentIndividualProfiles {
                agent_ind_id
                agent_ind_name
            }
            RecruiterProfiles {
                recruiter_id
                recruiter_name
                first_name
                last_name
                employer_name
                city
                state
                country
            }
            CropProfiles {
                crop_id
                crop_work_state
                crop_name
                crop_crop_id
                crop_agricultural_activity
            }
            AgricultureProfiles {
                agriculture_id
                agriculture_name
                agriculture_emp_name
                agriculture_state
                agriculture_county
            }
            WorkerHousingProfiles {
                workerHousing_id
                workerHousing_type_of_housing
                workerHousing_state
                workerHousing_state
                workerHousing_county
                workerHousing_name
            }
            MaterialTermsProfiles {
                material_terms_id
                material_terms_profile_name
                material_terms_section_number
                material_terms_summary
                material_terms_details
            }
        }
    }`;

export { profilesQuery };
